import { ChangeDetectionStrategy, Component, Input, output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ListboxModule } from 'primeng/listbox';
import { UserOrganization } from '../../models/organization';

@Component({
  selector: 'app-department-select',
  imports: [
    FormsModule,
    ListboxModule
  ],
  templateUrl: './department-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: ``,
})
export class DepartmentSelectComponent {
  @Input() items: UserOrganization[] = [];

  itemsChange = output<UserOrganization[]>();

  groupedItems: any[] = [];
  selectedItems: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['items'] && this.items) {
      if (this.items.length === 0) {
        this.groupedItems = [];
        this.selectedItems = [];
      } else {
        // 1. Costruiamo la struttura raggruppata per la p-listbox
        this.groupedItems = this.items.filter(i => i.associated && i.departments.length > 0).map(i => ({
          id: i.organizationId,
          name: i.name,
          isReadonly: !i.associated,
          // Mappiamo i dipartimenti interni
          items: i.departments.map(d => ({
            id: d.id,
            orgId: i.organizationId,
            dataKey: this.getCustomDataKey(d),
            name: d.name,
            associated: d.associated, // Stato iniziale dal padre
            isReadonly: !i.associated
          }))
        }));

        // 2. Pre-popoliamo le checkbox della listbox basandoci sul valore iniziale di 'isSelected'
        const initialSelections: any[] = [];
        this.groupedItems.forEach(group => {
          group.items.forEach((subItem: any) => {
            if (subItem.associated) {
              initialSelections.push(subItem);
            }
          });
        });
        this.selectedItems = initialSelections;
      }
    }
  }

  onSelectionChange() {
    // Ricostruiamo l'albero originale partendo da 'this.items' per non perdere i riferimenti e le altre proprietà
    const updatedTree: UserOrganization[] = this.items.map(org => {
      return {
        ...org,
        // Aggiorniamo l'array dei dipartimenti di questa specifica organizzazione
        departments: org.departments.map(dept => {
          // Un dipartimento è selezionato se il suo ID è presente nell'array selectedItems della listbox
          const isCurrentDeptSelected = this.selectedItems.some(
            selected => selected.dataKey === this.getCustomDataKey(dept)
          );
          
          return {
            ...dept,
            associated: isCurrentDeptSelected // Aggiorna il booleano nell'albero
          };
        })
      };
    });

    // Emettiamo l'intero albero aggiornato verso il componente padre
    this.itemsChange.emit(updatedTree);
  }

  private getCustomDataKey(item: any): string {
    return item ? `${item.id}_${item.orgId}` : '';
  }
}
